import React, { memo } from 'react';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';
import { Block } from '../../components/core';
import { FactorTrendHeader } from './factor-trend-header';
import { FactorTrendContent } from './factor-trend-content';

export const FactorTrendBlock = memo(function FactorTrendBlockInternal({ id }: { id: string }) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <FactorTrendHeader id={id} />
      </Block.Header>

      <Block.Content
        id={id}
        errorWrappers={[
          ...COMMON_ERROR_WRAPPERS,
          // MetricsErrorWrapper is last because it requires analysis, so we might as well do all the client-side error checks first
          MetricsErrorWrapper,
        ]}
      >
        <FactorTrendContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
